import { UrlConstants } from "../url.constants";
export class ApiMondiConstants {
    static URL = UrlConstants.API_V2 + "Mondi";
    static FUNCTION_GET_GENERATE_INVOICE = "GenerateMondiInvoiceReport";
    static FUNCTION_GET_WAYLEAVE_APPLICATIONS_BY_USER = "GetMndApplicationsByUser";
    static FUNCTION_SET_LOCATION = "SetMondiLocation";
    static FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST = "GetMondiRequiredDocumentsChecklist";
    static FUNCTION_GET_MND_MAP_DATA = "GetMndMapData";
    static FUNCTION_GET_MAPPED_LAYER_DATA = "GetMappedLayerData";
    static FUNCTION_GET_COMPARTMENT_DATA_BY_CODE = "GetCompartmentsDataByCode";
    static FUNCTION_GET_EXTERNAL_LINKS = "GetExternalLinks";
}
